import { Checkbox } from '@lyearn/ui';

import { useMicroSkillActions } from '../../context/MicroSkillsContext';
import { MicroSkillCellContainerProps } from '../MicroSkillCell/types';
import { MicroSkillSelectProps } from './types';

const MicroSkillSelect = (props: MicroSkillSelectProps) => {
  const { microSkill } = props;
  const { id } = microSkill;
  const { actions, uiState } = useMicroSkillActions(microSkill);

  return (
    <Checkbox
      aria-label={microSkill.name}
      checked={uiState.selectedSkillIds.includes(id)}
      size="medium"
      onClick={actions.toggleMicroSkillSelection}
    />
  );
};

const MicroSkillSelectContainer = (props: MicroSkillCellContainerProps) => {
  const { rowData } = props;
  const { type } = rowData;

  if (type !== 'MICRO_SKILL') {
    return null;
  }
  const { microSkill } = rowData;

  return <MicroSkillSelect microSkill={microSkill} />;
};

export default MicroSkillSelectContainer;
